// One entry point for the exporter: prepares the rows for the chart type
// and returns chart.js `{ type, data, options }` ready for an offscreen
// render. Map and table outputs are DOM visualizations and yield null.

import { buildBar, buildLine, buildPie, buildRadar, buildScatter, fieldLabel } from './builders';
import {
  prepareCategories,
  prepareSeries,
  preparePoints,
  prepareLine,
  prepareLineSeries,
  prepareStacked
} from '../prepare';

export function buildChart(chartType, rows, fields, config, palette) {
  const cfg = config || {};
  switch (chartType) {
    case 'bar': {
      const stacked = Boolean(cfg.stacked);
      // A series field splits the rows into one dataset per series value.
      const multi = cfg.seriesField ? prepareSeries(rows, fields, cfg) : null;
      if (multi) return { type: 'bar', ...buildBar(multi, stacked, palette) };
      const data = stacked
        ? prepareStacked(rows, cfg, fields)
        : prepareCategories(rows, fields, cfg);
      return { type: 'bar', ...buildBar(data, stacked, palette) };
    }
    case 'line': {
      const multi = prepareLineSeries(rows, fields, cfg);
      if (multi) return { type: 'line', ...buildLine(multi, null, palette) };
      return { type: 'line', ...buildLine(prepareLine(rows, fields, cfg), cfg.y, palette) };
    }
    case 'pie': {
      const multi = cfg.seriesField ? prepareSeries(rows, fields, cfg) : null;
      if (multi) return { type: 'pie', ...buildPie(multi, palette) };
      return { type: 'pie', ...buildPie(prepareCategories(rows, fields, cfg), palette) };
    }
    case 'radar': {
      const multi = cfg.seriesField ? prepareSeries(rows, fields, cfg) : null;
      if (multi) return { type: 'radar', ...buildRadar(multi, palette) };
      return { type: 'radar', ...buildRadar(prepareCategories(rows, fields, cfg), palette) };
    }
    case 'scatter': {
      const built = buildScatter(
        preparePoints(rows, fields, cfg),
        fieldLabel(fields, cfg.x),
        fieldLabel(fields, cfg.y),
        palette
      );
      return { type: 'scatter', ...built };
    }
    default:
      return null;
  }
}
